export const SWATCH_HATCH_STRIPE_PX = 2

// Matches the series chart's hatch tint (SERIES_AREA_FILL_OPACITY).
export const SWATCH_HATCH_TINT_PERCENT = 15
